































import {Component, Prop, Vue} from "vue-property-decorator";
import OverViewTable from "@/valchrom/views/dataset/OverViewTable.vue";
import JsonViewer from 'vue-json-viewer'
import DetailedView from "@/valchrom/views/dataset/DetailedView.vue";
import SeriesTabs from "@/valchrom/views/dataset/SeriesTabs.vue";
import Images from "@/valchrom/views/dataset/am/Images.vue";

@Component({
    components: {OverViewTable, JsonViewer, DetailedView, SeriesTabs, Images},
})
export default class CalRes extends Vue {
    name = 'CalRes'
    @Prop() am : any;
    @Prop() analyte : any;
}
